export const formatCurrency = (amount) => new Intl.NumberFormat().format(amount);
export const getPercentageAmount = (amount,percentage)=>((percentage/100)*amount);